/* eslint-disable no-restricted-imports */
import { Approve } from './actions/approve';
import { SimpleTransfer } from './actions/simpleTransfer';
import { Transfer } from './actions/transfer';
import { TransferFrom } from './actions/transferFrom';
import { Allowance } from './getters/allowance';
import { BalanceOf } from './getters/balanceOf';
import { Decimals } from './getters/decimals';
import { Name } from './getters/name';
import { Symbol } from './getters/symbol';
import { TotalSupply } from './getters/totalSupply';
var actions = {
    Transfer: Transfer,
    Approve: Approve,
    TransferFrom: TransferFrom,
    SimpleTransfer: SimpleTransfer,
};
var getters = {
    Allowance: Allowance,
    BalanceOf: BalanceOf,
    Decimals: Decimals,
    Name: Name,
    Symbol: Symbol,
    TotalSupply: TotalSupply,
};
var ERC20 = {
    actions: actions,
    getters: getters,
};
export { ERC20 };
